import React, { useEffect } from "react";
import { useBreadcrumbs } from "@/components/provider/BreadcrumbsProvider";
import { useNavigate, useSearchParams } from "react-router-dom";
import { usePostAuthPodioMutation } from "@/store/rest_api";

const PodioCallback = () => {
  const { setPage, setSection } = useBreadcrumbs();
  const navigate = useNavigate();
  const [queryParams] = useSearchParams();
  const [postAuthPodio, postAuthPodioResponse] = usePostAuthPodioMutation();

  useEffect(() => {
    setSection("Integrations");
    setPage("Podio");
  }, []);

  useEffect(() => {
    const authzCode = queryParams.get("code");
    const integrationId = queryParams.get("state");
    if (authzCode && integrationId) {
      postAuthPodio({ code: authzCode, integrationId });
    }
  }, []);

  useEffect(() => {
    if (postAuthPodioResponse.isError || postAuthPodioResponse.isSuccess) {
      const timer = setTimeout(() => {
        navigate("/integrations");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [postAuthPodioResponse.isError, postAuthPodioResponse.isSuccess]);

  if (postAuthPodioResponse.isSuccess) {
    return <div>Success! Redirecting...</div>;
  }

  if (postAuthPodioResponse.isError) {
    return <div>Failure, redirecting... </div>;
  }

  return <div>Podio callback</div>;
};

export default PodioCallback;
